import { AdPreviewCard } from "@/app/Promotions/Components/AdPreviewCard";
import { PromotionCreative } from "@/app/Promotions/GraphQL/promotionCreativeQuery";
import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { useTranslations } from "use-intl";

export function AdPreviewDialog({
  creative,
}: {
  creative: PromotionCreative | null;
}) {
  const t = useTranslations("promotion.preview");

  return (
    <BaseDialog title={t("title")}>
      {creative ? (
        <AdPreviewCard creative={creative} />
      ) : (
        <p className="text-sm text-gray-500">{t("unavailable")}</p>
      )}
    </BaseDialog>
  );
}
